function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3333 2C15.3333 2.27614 15.1095 2.5 14.8333 2.5H5.16666C4.89051 2.5 4.66666 2.27614 4.66666 2C4.66666 1.72386 4.89051 1.5 5.16666 1.5H14.8333C15.1095 1.5 15.3333 1.72386 15.3333 2ZM12.6667 6C12.6667 6.27614 12.4428 6.5 12.1667 6.5H5.16666C4.89051 6.5 4.66666 6.27614 4.66666 6C4.66666 5.72386 4.89051 5.5 5.16666 5.5H12.1667C12.4428 5.5 12.6667 5.72386 12.6667 6ZM9.99999 10.1667C9.99999 10.4428 9.77613 10.6667 9.49999 10.6667H5.16666C4.89051 10.6667 4.66666 10.4428 4.66666 10.1667C4.66666 9.89052 4.89051 9.66667 5.16666 9.66667H9.49999C9.77613 9.66667 9.99999 9.89052 9.99999 10.1667Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.35383 12.1467C4.16249 11.954 3.85383 11.9507 3.65783 12.138L2.74983 13.01V1.83333C2.74983 1.55733 2.52583 1.33333 2.24983 1.33333C1.97383 1.33333 1.74983 1.55733 1.74983 1.83333V13.0533L0.852495 12.15C0.664495 11.9613 0.361828 11.9533 0.164495 12.1327C-0.0475054 12.326 -0.0555054 12.658 0.145828 12.8607L1.74583 14.47C2.00649 14.732 2.42783 14.732 2.68783 14.47L4.34649 12.8633C4.54849 12.6687 4.55116 12.3453 4.35383 12.1467Z",
  fill: "white"
});

function SvgIconSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/iconSort.ff21b6a3.svg";
export { ForwardRef as ReactComponent };